const fragranceMap = [
  {
    name: 'Floret',
    dataKey: 'floret',
    type: 'recovery',
    description:
      'Floret - fresh, floral, rose, gardania with earthy sandalwood',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/floret-fragrance.png?v=1713287368',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/Floret.svg?v=1734011599',
    coreOnly: false
  },
  {
    name: 'Vanilla suede',
    dataKey: 'vanilla suede',
    type: 'recovery',
    description: 'Vanilla suede - vanilla, jasmine, sandalwood',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/vanilla-fragrance.png?v=1713286884',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/Vanila.svg?v=1734011599',
    coreOnly: false
  },
  {
    name: 'Go coco',
    dataKey: 'coco',
    type: 'recovery',
    description:
      'Go coco - rich, creamy coconut and sweet hints of honeysuckle',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/coco-fragrance.png?v=1713286884',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/Coconut.svg?v=1734011599',
    coreOnly: false
  },
  {
    name: 'Strike a rose',
    dataKey: 'rose',
    type: 'recovery',
    description:
      'Strike a rose - rose, blackcurrant, sandalwood, orange blossom',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/rose-fragrance.png?v=1713286884',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/Rose.svg?v=1734011598',
    coreOnly: false
  },

  {
    name: 'Nude peach',
    dataKey: 'peach',
    description: 'Nude peach - peach nectar, mandarin, lemon zest, jasmine',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/peach-fragrance.png?v=1713286884',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Nude_Peach.svg?v=1738015337',
    coreOnly: true
  },
  {
    name: 'True lovender',
    dataKey: 'lavender',
    description: 'True lovender - lavender, eucalyptus, bergamont',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/lovender-fragrance.png?v=1713286884',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/True_Lovender.svg?v=1738015337',
    coreOnly: true
  },
  {
    name: 'Takes Two to mango',
    dataKey: 'mango',
    description: 'Takes two to mango - mango, grapefruit, and mandarin',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/mango-fragrance.png?v=1713286884',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Takes_Two_to_Mango.svg?v=1738015337',
    coreOnly: true
  },
  {
    name: 'All you calyptus',
    dataKey: 'essential oils',
    description: 'All you calyptus - eucalyptus, mint, lavender, rosemary',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/calyptus-fragrance.png?v=1713287477',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/All_You_Calytus.svg?v=1738015337',
    coreOnly: true
  },
  {
    name: 'Pearfection',
    dataKey: 'pear',
    description: 'Pearfection - pear, apple, sweet musk, subtle florals',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/pear-fragrance.png?v=1713286885',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Pearfection.svg?v=1738015337)',
    coreOnly: true
  },
  {
    name: 'Fragrance free',
    dataKey: 'fragrance-free',
    type: 'recovery',
    description: 'Fragrance free - for sensitive scalp',
    image:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/none-fragrance.png?v=1713286884',
    imageSecondary:
      'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/no-fragrance.svg?v=1734011598',
    coreOnly: false
  }
];

const discontinuedFragranceMap = [
  {
    name: 'Cherry Bl(Awesome)',
    dataKey: 'cherry'
  }
];

const fragrancesAsLabelValue = fragranceMap.map((fragrance) => {
  return {
    label: fragrance.name,
    value: fragrance.dataKey
  };
});

const discontinuedFragrancesAsValue = discontinuedFragranceMap.map(
  (fragrance) => {
    return fragrance.dataKey;
  }
);

const mapFragranceKeyToLabel = (fragrance) => {
  const trimmedFragrance = fragrance?.trim();
  const fragranceObj = fragranceMap.find((f) => f.dataKey === trimmedFragrance);
  return fragranceObj ? fragranceObj.name : '';
};

const parseFragrancesFromHtmlElement = (selector) => {
  const fragranceElements = document.querySelectorAll(selector);
  fragranceElements?.forEach((fragranceElement) => {
    const fragrance = mapFragranceKeyToLabel(fragranceElement.textContent);
    fragranceElement.textContent = fragrance;
  });
};

export {
  fragranceMap,
  discontinuedFragranceMap,
  mapFragranceKeyToLabel,
  fragrancesAsLabelValue,
  discontinuedFragrancesAsValue,
  parseFragrancesFromHtmlElement
};
